import { AlertCircle } from 'lucide-react';
import { ReactNode } from 'react';

interface WizardStepContentProps {
  children: ReactNode;
  saveError: string | null;
}

export function WizardStepContent({ children, saveError }: WizardStepContentProps) {
  return (
    <div style={{ padding: '2.5rem', flex: 1, overflowY: 'auto' }}>
      {saveError && (
        <div
          style={{
            padding: '1rem 1.25rem',
            background: 'linear-gradient(135deg, #f4d9e5 0%, #e8bccf 100%)',
            border: '1px solid #fca5a5',
            borderRadius: '8px',
            color: '#991b1b',
            marginBottom: '2rem',
            fontSize: '0.9rem',
            fontWeight: 500,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <AlertCircle size={18} color="#8E0B56" />
            <span>Erreur lors de la sauvegarde: {saveError}</span>
          </div>
        </div>
      )}

      {children}
    </div>
  );
}
